import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { processGoogleSession } from '../services/api';
import { useAuth } from '../context/AuthContext';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser, setToken } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL hash fragment
        const hash = location.hash;
        const params = new URLSearchParams(hash.replace('#', ''));
        const sessionId = params.get('session_id');

        if (!sessionId) {
          console.error('No session_id found in URL');
          navigate('/login', { replace: true });
          return;
        }

        // Exchange session_id for user data and token
        const response = await processGoogleSession(sessionId);
        const { token, user } = response.data;

        // Store token and user
        localStorage.setItem('token', token);
        setToken(token);
        setUser(user);

        // Navigate to dashboard with user data
        navigate('/dashboard', { replace: true, state: { user } });
      } catch (error) {
        console.error('Google auth failed:', error);
        navigate('/login', { 
          replace: true, 
          state: { error: 'Google sign-in failed. Please try again.' } 
        });
      }
    };

    processAuth();
  }, [location.hash, navigate, setUser, setToken]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--background)]">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-[var(--primary)] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-lg font-medium">Signing you in with Google...</p>
        <p className="text-sm text-[var(--text-secondary)] mt-2">Please wait</p>
      </div>
    </div>
  );
}

export default AuthCallback;
